<template>
    <div>
        <c-panel>                          
            <div class="container-table u-mt-10">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 90px;">Matrícula</th>
                            <th>Nome</th>
                            <th>Data de Nascimento</th>                                                       
                            <th class="u-text-center">Situação da Matrícula</th>
                            <th>Ano Letivo</th>
                            <th>Status</th>
                            <th v-if="$store.state.user.tipo < 2 || $store.state.user.tipo == 6 || $store.state.user.tipo == 4" style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                                               
                        <tr v-for="item in items" :key="item.id">                            
                            <td class="hidden-mobile">{{ item.num_matricula }}</td>
                            <td>
                                {{ item.nome }}
                            </td>
                            <td><b class="hidden-desktop">DATA NASC.:</b> {{ (item.data_nascimento) ? $moment(item.data_nascimento).format('DD/MM/YYYY') : '-' }}</td>                                                         
                            <td class="u-text-center">
                                <b class="hidden-desktop">SITUAÇÃO:</b>
                                {{ $CONSTANTS.SITUACAO_MATRICULA[item.situacao_matricula] }}
                                
                            </td>
                            <td>{{ item.ano_letivo }}</td>
                            <td>{{ $CONSTANTS.HISTORICO_PENDENTE[item.historico_pendente] }}</td>
                            <td class="u-text-center acao" v-if="$store.state.user.tipo < 2 || $store.state.user.tipo == 6 || $store.state.user.tipo == 4">

                                <el-button @click="openModalPendencia(item)" title="Mais ações" type="primary" icon="el-icon-menu" size="mini" plain></el-button>                                

                            </td>                           
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                                <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                            </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
        

        <el-dialog append-to-body :close-on-click-modal="false" title="EDITAR PENDÊNCIA DE HISTÓRICO" width="30%" :visible.sync="dialogPendenciaHistorico">
            <div v-if="dialogPendenciaHistorico" style="margin-top: 20px;">
                <editarPendenciaDialog 
                    :visible.sync="dialogPendenciaHistorico"
                    :matPendHistorico="this.matPendHistorico"
                    :formPendencia="formPendencia"
                    v-on:onSubmit="emitFormPendencia"
                    
                />
            </div>
        </el-dialog>

    </div>
</template>
<script>

import editarPendenciaDialog from '../EditarPendenciaDialog/'

export default {
    components: {
        editarPendenciaDialog
    },
    data: () => ({
        statusList: true, 
        filtro: {},
        items: [],
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        instituicao: '',
        dialogPendenciaHistorico: false,
        matPendHistorico: 0,
        formPendencia: {}
        
    }),
    mounted () {
      
        if(this.$store.state.user.tipo <= 1 && this.$store.state.config.instituicao){

            this.instituicao = this.$store.state.config.instituicao.id;            

        }else{

            this.instituicao = this.$store.state.instituicoes;
        }

        this.getHitoricosPendentes()  
        
    },
    methods: {

        getHitoricosPendentes(){     

            let i = this.$store.state.config.instituicao.id;

            this.statusList = false;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getHistoricoPendente/${i}?page=` + this.paginate.page, this.$store.getters.getHeaderAuth).then(response => {
                               
                this.items = response.data.dados;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;              
                

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });


        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getHitoricosPendentes();
        },
        openModalPendencia(item){      
            this.dialogPendenciaHistorico = true    
            
            this.matPendHistorico = ''
            this.formPendencia = {}

            this.matPendHistorico = item.historico_pendente
            this.formPendencia.ano_letivo = item.ano_letivo
            this.formPendencia.data_nascimento = item.data_nascimento            
            this.formPendencia.id_aluno = item.id_aluno
            this.formPendencia.id_matricula = item.id_matricula
            this.formPendencia.nome = item.nome
            this.formPendencia.num_matricula = item.num_matricula
            this.formPendencia.situacao_matricula = item.situacao_matricula
            
        },
        emitFormPendencia(){ 

            this.dialogPendenciaHistorico = false
    
            this.getHitoricosPendentes();
        }
    }
}
</script>